export enum ColorOptions {
	White = 'white',
	WhiteGrey = 'whiteGrey',
	LightGrey = 'lightGrey',
	LightBlue = 'lightBlue',

	Blue = 'blue',
	Green = 'green',
	Red = 'red',
	Violet = 'violet',
}
export default ColorOptions;

export const lightColorOptions = new Set<ColorOptions>([ColorOptions.White, ColorOptions.WhiteGrey, ColorOptions.LightGrey, ColorOptions.LightBlue]);

// An unset color counts as light too — components like HeroCard default their bgColor to White
// when the CMS value isn't set, so a missing color renders exactly as light as ColorOptions.White.
export const isLightColor = (color?: ColorOptions): boolean => !color || lightColorOptions.has(color);

export interface LinkType {
	url: string;
	name?: string;
	target?: string;
}

export enum GridLayoutTypeOptions {
	OneThirdImage = 'oneThirdImage',
	HalfImage = 'halfImage',
	TwoThirdsImage = 'twoThirdsImage',
}

export enum LightBgColor {
	LightBlue = 'lightBlue',
	Lilac = 'lilac',
	Turqoise = 'turqoise',
	Grey = 'grey',
	Sand = 'sand',
	Pink = 'pink',
}
